/**
 * "Signing in & workspaces" — Auth section (ADR-0074).
 * Reconciled from apps/web SignInPage (Auth0 redirect + signup intent),
 * AuthGuard, and the tenant model (tenant.graphql, WorkspaceProvider).
 */
import type { DocPageContent } from '../types';

export const AUTH_SIGN_IN_PAGE: DocPageContent = {
  slug: 'auth/sign-in',
  titleKey: 'docs.auth.signin.title',
  descriptionKey: 'docs.auth.signin.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.auth.signin.lead' },

    { kind: 'heading', level: 2, id: 'signing-in', textKey: 'docs.auth.signin.flow.heading' },
    { kind: 'paragraph', textKey: 'docs.auth.signin.flow.body' },
    {
      kind: 'steps',
      steps: [
        {
          titleKey: 'docs.auth.signin.step.open.title',
          textKey: 'docs.auth.signin.step.open.text',
        },
        {
          titleKey: 'docs.auth.signin.step.authenticate.title',
          textKey: 'docs.auth.signin.step.authenticate.text',
        },
        {
          titleKey: 'docs.auth.signin.step.land.title',
          textKey: 'docs.auth.signin.step.land.text',
        },
      ],
    },
    {
      kind: 'callout',
      tone: 'note',
      titleKey: 'docs.auth.signin.newAccount.title',
      textKey: 'docs.auth.signin.newAccount.body',
    },

    { kind: 'heading', level: 2, id: 'workspaces', textKey: 'docs.auth.signin.workspaces.heading' },
    { kind: 'paragraph', textKey: 'docs.auth.signin.workspaces.body' },
    {
      kind: 'definitions',
      items: [
        {
          termKey: 'docs.auth.signin.workspace.personal.term',
          descKey: 'docs.auth.signin.workspace.personal.desc',
        },
        {
          termKey: 'docs.auth.signin.workspace.shared.term',
          descKey: 'docs.auth.signin.workspace.shared.desc',
        },
      ],
    },

    {
      kind: 'heading',
      level: 2,
      id: 'create-switch',
      textKey: 'docs.auth.signin.manage.heading',
    },
    {
      kind: 'list',
      itemKeys: [
        'docs.auth.signin.manage.create',
        'docs.auth.signin.manage.switch',
        'docs.auth.signin.manage.name',
      ],
    },

    { kind: 'heading', level: 2, id: 'isolation', textKey: 'docs.auth.signin.isolation.heading' },
    { kind: 'paragraph', textKey: 'docs.auth.signin.isolation.body' },
    {
      kind: 'callout',
      tone: 'important',
      titleKey: 'docs.auth.signin.isolation.note.title',
      textKey: 'docs.auth.signin.isolation.note.body',
      links: {
        trust: { target: { path: '/trust' }, labelKey: 'docs.common.link.trust' },
      },
    },

    { kind: 'heading', level: 2, id: 'sign-out', textKey: 'docs.auth.signin.signout.heading' },
    { kind: 'paragraph', textKey: 'docs.auth.signin.signout.body' },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.auth.signin.next.team.title',
          textKey: 'docs.auth.signin.next.team.text',
          to: { docSlug: 'dashboard/team' },
        },
        {
          titleKey: 'docs.auth.signin.next.endUser.title',
          textKey: 'docs.auth.signin.next.endUser.text',
          to: { docSlug: 'auth/end-user-auth' },
        },
      ],
    },
  ],
};
